import { Transcript, Export } from '../types';
import { apiClient } from './api';

interface TranscriptResponse {
  data: Transcript;
}

interface ExportOption {
  format: string;
  description: string;
  available: boolean;
}

class TranscriptsService {
  private baseUrl = '/transcripts';

  async getTranscript(audioFileId: string): Promise<Transcript> {
    const response = await apiClient.get<TranscriptResponse>(
      `${this.baseUrl}/${audioFileId}`
    );
    return response.data.data;
  }

  async updateTranscript(
    audioFileId: string,
    updates: Partial<Pick<Transcript, 'notes' | 'summary'>>
  ): Promise<Transcript> {
    const response = await apiClient.put<TranscriptResponse>(
      `${this.baseUrl}/${audioFileId}`,
      { transcript: updates }
    );
    return response.data.data;
  }

  async requestExport(
    audioFileId: string,
    format: 'pdf' | 'docx'
  ): Promise<{ data: Export }> {
    const response = await apiClient.post<{ data: Export }>(
      `${this.baseUrl}/${audioFileId}/request-export`,
      {
        format,
      }
    );
    return response.data;
  }

  async getExportOptions(
    audioFileId: string
  ): Promise<{ options: ExportOption[] }> {
    const response = await apiClient.get<{ options: ExportOption[] }>(
      `${this.baseUrl}/${audioFileId}/export-options`
    );
    return response.data;
  }
}

export const transcriptsService = new TranscriptsService();
